import React from "react";
import { useParams } from "react-router-dom";

const Destination = () => {
  const { type } = useParams();
  return <div>Destination: {type}</div>;
};

export default Destination;
